import { render, staticRenderFns } from "./WidgetColor.vue?vue&type=template&id=543477b1&scoped=true"
import script from "./WidgetColor.vue?vue&type=script&lang=js"
export * from "./WidgetColor.vue?vue&type=script&lang=js"
import style0 from "./WidgetColor.vue?vue&type=style&index=0&id=543477b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543477b1",
  null
  
)

export default component.exports